import './input.css'

function autoCopyInputNameToParentDiv() {
  function syncDivNameWithInput() {
    document.querySelectorAll('div > input[name]').forEach(input => {
      const div = input.parentElement
      if (
        div &&
        (!div.hasAttribute('name') || div.getAttribute('name') !== input.name)
      ) {
        div.setAttribute('name', input.name)
      }
    })
  }

  // Exécute au chargement initial
  window.addEventListener('DOMContentLoaded', syncDivNameWithInput)

  // Observe les changements dynamiques du DOM
  const observer = new MutationObserver(() => {
    syncDivNameWithInput()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['name'],
  })
}

try {
  autoCopyInputNameToParentDiv()
} catch (error) {
  console.log('🚀 ~ error:', error)
}
